import api from "services/api";
import { API_URL_VERSION } from "constants/environment";
import { toSearchFilter } from "utils/utils";

export const DOCUMENTS_PERMITTEES = API_URL_VERSION + "documentos-permissionarios";
export const LIST = "listar";
export const SEND_TO_DETRAN = "enviar-detran";
export const PRINT_CARTEIRA = "imprimir-carteira-pdf"

export const documentsPermitteesService = {
    create: async (data) => {
        try {
            const response = await api.post(`${DOCUMENTS_PERMITTEES}`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "documents.messages.errors.create";
        }
    },

    update: async (data, id) => {
        try {
            const response = await api.put(`${DOCUMENTS_PERMITTEES}/${id}`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "documents.messages.errors.update";
        }
    },

    list: async (parentID) => {
        try {
            const response = await api.get(`${DOCUMENTS_PERMITTEES}/${parentID}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "documents.messages.errors.list";
        }
    },

    listWithFilters: async (parentId, params = {}) => {
        try {
            const response = await api.post(`${DOCUMENTS_PERMITTEES}/${LIST}/${parentId}`, toSearchFilter(params));
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "documents.messages.errors.list";
        }
    },

    find: async (id) => {
        try {
            const response = await api.get(`${DOCUMENTS_PERMITTEES}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "documents.messages.errors.find";
        }
    },

    delete: async (id) => {
        try {
            const response = await api.delete(`${DOCUMENTS_PERMITTEES}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "documents.messages.errors.delete";
        }
    },

    sendToDetran: async (data, id) => {
        try {
            const response = await api.post(`${DOCUMENTS_PERMITTEES}/${SEND_TO_DETRAN}/${id}`, data);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.erros_validacao || "permittees.messages.errors.send-detran";
            throw new Error(errorMessage);
        }
    },

    printCarteiras: async (codes) => {
        try {
            const response = await api.get(`${DOCUMENTS_PERMITTEES}/${PRINT_CARTEIRA}/${codes}`, {
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            throw error.response?.data?.message || "permittees.messages.errors.print-carteira";
        }
    },

};